import { render, staticRenderFns } from "./wallet-history-details.vue?vue&type=template&id=87ac9992"
import script from "./wallet-history-details.vue?vue&type=script&lang=js"
export * from "./wallet-history-details.vue?vue&type=script&lang=js"
import style0 from "./wallet-history-details.vue?vue&type=style&index=0&id=87ac9992&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports